import { render, staticRenderFns } from "./claimSettle.vue?vue&type=template&id=61519a1a&scoped=true&"
import script from "./claimSettle.vue?vue&type=script&lang=js&"
export * from "./claimSettle.vue?vue&type=script&lang=js&"
import style0 from "./claimSettle.vue?vue&type=style&index=0&id=61519a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61519a1a",
  null
  
)

export default component.exports